var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"dext5",rawName:"v-dext5:loaded",value:(_vm.handleLoaded),expression:"handleLoaded",arg:"loaded"}],staticClass:"form-control-container",attrs:{"id":_vm.editorId}})
}
var staticRenderFns = []

export { render, staticRenderFns }